import { useSelector } from 'react-redux';
import { isRouteOneLender, ROUTE_ONE_LENDER_ID } from 'modules/core/constants/routeOneLenders.const';
import type { ILenderState } from 'store/reducers/lenders.reducer';
import type { RootState } from 'store/store';

const selectLender = (state: RootState): ILenderState => state.lenders.lendersHashTable[state.lenders.currentLenderId];

export const useIsMtbLender = (isLender: boolean): boolean => {
  const lender = useSelector(selectLender);

  return isLender && isRouteOneLender(lender?.route_one_id, ROUTE_ONE_LENDER_ID.MTB);
};
